// extracted by mini-css-extract-plugin
export default {"home":"Template_home__HKWMk","homeRight":"Template_homeRight__ZcBi-","homeLeft":"Template_homeLeft__HDnHQ"};